export default "__VITE_ASSET__DL4WYdIo__"